import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Card as AntdCard } from "antd";

const props = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padding: PropTypes.number,
  style: PropTypes.object,
  onClick: PropTypes.func,
  userGuideStep: PropTypes.string,
};

const Card = ({ children, className, padding, style, onClick, userGuideStep }) => {
  return (
    <StyledCard
      className={`${className ? className : ""}`}
      padding={padding}
      style={style}
      onClick={() => {
        if (onClick) onClick();
      }}
      user-guide-step={userGuideStep || ""}
    >
      {children}
    </StyledCard>
  );
};

const StyledCard = styled(AntdCard)`
  overflow: hidden;

  .ant-card-body {
    padding: ${(props) => (props.padding !== undefined ? props.padding : 12)}px !important;
    height: 100%;

    &::before,
    &::after {
      display: none;
    }
  }
`;

Card.propTypes = props;

export default Card;
